import React from "/vendor/react";
import executeCheck from "/lib/mutation/executeCheck"
import {useApolloClient} from "/lib/component/util";
import {useExecuteCheckStatusToast} from "/lib/component/toast";
import './holdToConfirm.css'

interface Props {
  entity?: {
    id?: string;
    name?: string;
    namespace?: string;
  };
}

const EntityDetailsOOSButton = ({
   entity = {},
 }: Props) => {
  const { name, namespace } = entity;

  const client = useApolloClient()

  const onExecute = React.useCallback((vars) => executeCheck(client, vars), [
    client,
  ]);

  const createExecuteCheckStatusToast = useExecuteCheckStatusToast();

  const executeOutOfServiceCheck = () => {
    const promise = onExecute({ id: `srn:checks:${namespace}:out-of-service`, subscriptions: [`entity:${name}`] });
    createExecuteCheckStatusToast(promise, {
      checkName: 'out-of-service',
      namespace: namespace,
      entityName: name,
      });
  };

  let duration = 1600,
    success = (button: { classList: { add: (arg0: string) => void; remove: (arg0: string) => void } }) => {
      button.classList.add('success');
      executeOutOfServiceCheck();
      setTimeout(() => {
        button.classList.remove('success')
      }, 3000)
    };

  document.querySelectorAll('.button-hold-oos').forEach(button => {
    // @ts-ignore
    button.style.setProperty('--duration', duration + 'ms');
    ['mousedown', 'touchstart', 'keypress'].forEach(e => {
      button.addEventListener(e, ev => {
        // @ts-ignore
        if(e != 'keypress' || (e == 'keypress' && ev.which == 32 && !button.classList.contains('process'))) {
          // @ts-ignore
          clearTimeout(button.timeout);  // Clear any existing timeout
          button.classList.add('process');
          // @ts-ignore
          button.timeout = setTimeout(success, duration, button);
        }
      });
    });
    ['mouseup', 'mouseout', 'touchend', 'keyup'].forEach(e => {
      button.addEventListener(e, ev => {
        // @ts-ignore
        if(e != 'keyup' || (e == 'keyup' && ev.which == 32)) {
          button.classList.remove('process');
          // @ts-ignore
          clearTimeout(button.timeout);
        }
      }, false);
    });
  });



  return (
    <button className="button-hold-oos">
      <div>
        <svg className="icon" viewBox="0 0 16 16">
          <polygon
            points="1.3,6.7 2.7,8.1 7,3.8 7,16 9,16 9,3.8 13.3,8.1 14.7,6.7 8,0"></polygon>
        </svg>
        <svg className="progress" viewBox="0 0 32 32">
          <circle r="8" cx="16" cy="16"/>
        </svg>
        <svg className="tick" viewBox="0 0 24 24">
          <polyline points="18,7 11,16 6,12"/>
        </svg>
      </div>
      Out Of Service
    </button>
  );
};


export default EntityDetailsOOSButton;
